import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ProjetoCulturalService from '../../../../services/projetoCultural-auth';
import Projeto from './projeto';


const ListarProjetos = () => {


    const [projetos, setProjetos] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [projeto, setProjeto] = useState("");


    async function fetchProjetos() {
        const response = await ProjetoCulturalService.listar();
        if (response.data.length >= 1) {
            setProjetos(response.data)
            setVazio(false)
        } else {
            setProjetos([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setProjeto(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o projeto cultural?')) {
            await ProjetoCulturalService.deletar(id)
            alert("Projeto Cultural deletado com sucesso!")
            fetchProjetos();
        }
    }

    useEffect(() => {
        fetchProjetos();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/renuncias/projetocultural/editar/${projeto}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setProjetos={setProjetos}
                        setVazio={setVazio}
                        fetchProjetos={fetchProjetos}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {projetos.map((projeto, index) =>
                                <Projeto
                                    fetchProjetos={fetchProjetos}
                                    projeto={projeto}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarProjetos;